export const PurchaseRoute = {
  Miners: (): string => '/miners/active',
  TrialMiners: (): string => '/miners/active?flag=trial',
  FirstPurchase: (): string => '/user/first-purchase',
};
